const g = 1e3, h = 6e4, d = 36e5, D = 864e5, S = {
  "en-US": {
    SHORT_MONTHS: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    LONG_MONTHS: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  "pt-BR": {
    SHORT_MONTHS: [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez"
    ],
    LONG_MONTHS: [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ]
  }
}, M = {
  "pt-BR": {
    now: "agora",
    yesterday: "ontem"
  },
  "en-US": {
    now: "now",
    yesterday: "yesterday"
  }
};
function T(e) {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
const l = (e, t) => {
  const r = new Date(e), o = r.getDate(), n = S[t].LONG_MONTHS[r.getMonth()];
  if (t.startsWith("en")) {
    const a = T(o);
    return `${n} ${o}${a}`;
  }
  return `${o} de ${n}`;
}, y = (e) => new Date(e).toLocaleTimeString(navigator.language, {
  hour: "2-digit",
  minute: "2-digit"
}).replace("AM", "").replace("PM", ""), m = (e) => new Date(Date.now() - 864e5 * e), O = (e, t) => S[t].SHORT_MONTHS[e.getMonth()], N = (e, t) => {
  var c, u;
  const r = e.getTime(), n = Date.now() - r, a = m(1);
  if (n < 6e4)
    return (c = M[t]) == null ? void 0 : c.now;
  if (n < 36e5)
    return `${Math.min(Math.round(n / 6e4), 59)} min`;
  if (n < 864e5)
    return `${Math.min(Math.round(n / 36e5), 23)} h`;
  if (e.toDateString() === a.toDateString())
    return (u = M[t]) == null ? void 0 : u.yesterday;
  const i = O(e, t);
  if (e.getFullYear() === new Date(Date.now()).getFullYear()) {
    const s = `0${e.getDate()}`.slice(-2);
    return t === "pt-BR" ? `${s} ${i}` : ` ${i} ${s} `;
  }
  return `${i} ${e.getFullYear()}`;
}, _ = (e, t) => new Date(e).getTime() > new Date(t).getTime(), w = (e, t) => !_(e, t), f = (e) => {
  let t;
  try {
    return t = new Date(e || ""), new Intl.DateTimeFormat(navigator.language, {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric"
    }).format(t);
  } catch {
    return;
  }
};
export {
  D as DAY_TO_MS,
  d as HOUR_TO_MS,
  h as MINUTE_TO_MS,
  g as SECOND_TO_MS,
  _ as checkFirstDateIsNewer,
  w as checkFirstDateIsOlder,
  f as dateStringToDateTimeLocaleString,
  l as getDayAndLongMounth,
  m as getDaysAgo,
  y as getHourAndMinute,
  O as getShortMonth,
  N as getTimeAgoString
};
